<template>
    <div>
        <table style="margin-left: 10px;">
            <tr>
                <td>
                    <i class="icon iconfont icon-square complete-legend"
                       style="font-size: 30px; margin-right: 0"/>
                </td>
                <td>
                    <span @click="changeMode('complete')" class="btn-task-complete"
                          :class="{active: mode === 'complete'}">
                        符合进度
                    </span>
                </td>
                <td>
                    <i class="icon iconfont icon-square slight-delay-legend"
                       style="font-size: 30px; margin-right: 0"/>
                </td>
                <td>
                    <span @click="changeMode('slight-delay')" class="btn-task-slight-delay"
                          :class="{active: mode === 'slight-delay'}">
                        延期但不影响进度
                    </span>
                </td>
                <td>
                    <i class="icon iconfont icon-square serious-delay-legend"
                       style="font-size: 30px; margin-right: 0"/>
                </td>
                <td>
                    <span @click="changeMode('serious-delay')" class="btn-task-serious-delay"
                          :class="{active: mode === 'serious-delay'}">
                        延期并影响后期主要计划
                    </span>
                </td>
                <td style="width: 20px;"/>
                <td>
                    计划日期：
                </td>
                <td style="font-size: 15px;">
                    {{range.start}} —— {{range.end}}
                </td>
            </tr>
        </table>
        <div class="table-content" ref="table" :style="{height:(screenHeight - 140) + 'px'}"><!---->
            <div class = "left-content">
                <div class = "table-head">
                    <table class= "full-table">
                        <thead>
                        <tr>
                            <th rowspan="2" class="plan-title" style="width: 180px;height:65px;line-height: 65px;border-right:none;">
                                <span style="color: red;">*</span>项目阶段
                            </th>
                            <th rowspan="2" class="plan-title" style="width: 180px;height:65px;line-height: 65px;border-right:none;">
                                <span style="color: red;width: 180px;">*</span>项目任务
                            </th>
                            <th rowspan="2"
                                style="font-weight: bold; background: rgb(198, 226, 255); text-align: center;width: 80px;height:65px;line-height: 65px;border-right:none;">
                                时间类型
                            </th>
                        </tr>
                        </thead>
                    </table>
                </div>
                <div class="table-left">
                    <div class = "table"
                         ref="firstColLayer"
                         data-_ref="firstColLayer"
                    >
                        <table class= "full-table">
                            <tbody>
                            <template v-for="(value, stage) in groupedTasks">
                                <template v-for="(task, j) in value">
                                    <template v-for="k in 2">
                                        <tr :key="stage + j + k">
                                            <td v-if="j === 0 && k === 1" :rowspan="value.length * 2" style="width: 180px;text-align: center;height:64px;">
                                                {{stage}}
                                            </td>
                                            <td v-if="k === 1" rowspan="2" style="width: 180px;text-align: center;height:64px;">{{task.content}}</td>
                                            <td style="width: 80px;text-align: center;height:32px;">
                                                {{ k === 1 ? '实际时间' : '计划时间' }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class = "right-content" ref="right" style="min-width:200px;">
                <!--首行固定-->
                <div class = "table-head"
                     ref="firstRowLayer"
                     data-_ref="firstRowLayer">
                    <table class= "full-table">
                        <thead>
                        <tr>
                            <td v-for="month in months" v-bind:key="'month.month' + month.month" :colspan="month.weeks"
                                style="height: 32px; text-align: center;">
                                {{ month.month.substr(0, 4) + '年' + parseInt(month.month.substr(4, 2)) + '月' }}
                            </td>
                        </tr>
                        <tr>
                            <template v-for="month in months">
                                <td v-for="weekIndex in month.weeks" class="width32 height32" :key="'month.weekIndex' + month.month + weekIndex"
                                    style="width: 32px; height: 32px; text-align: center;">
                                    {{weekIndex}}
                                </td>
                            </template>
                        </tr>
                        </thead>
                    </table>
                </div>
                <!--正常表格内容(只有表格内容，没有表头和首列)-->
                <div class="table"
                     style="overflow-y:auto;overflow-x: scroll;"
                     ref="tableContainer"
                     @scroll="tableDivScroll($event)"
                >
                    <table class="content-table" ref="contTable">
                        <tbody ref="tbody">
                        <template v-for="(value, stage) in groupedTasks">
                            <template v-for="(task, j) in value">
                                <template v-for="k in 2">
                                    <tr :key="stage + j + k">
                                        <template v-if="k === 1">
                                            <td v-for="week in weeks" v-bind:key="week + k" :class="{
                                        'slight-delay': task.status[week] === 'slight-delay',
                                        'serious-delay': task.status[week] === 'serious-delay',
                                        'complete': task.status[week] === 'complete',
                                        milestone: milestoneStatusIsNotNull(task.uuid, week),
                                        'milestone-complete': milestoneStatusEquals(task.uuid, week, 'complete'),
                                        'milestone-slight-delay': milestoneStatusEquals(task.uuid, week, 'slight-delay'),
                                        'milestone-serious-delay': milestoneStatusEquals(task.uuid, week, 'serious-delay'),
                                        height32: true, width32: true,
                                        pointer: task.status.hasOwnProperty(week),
                                    }" @click="mark(task, week, mode)">
                                        <template v-if="milestoneStatusIsNotNull(task.uuid, week, k)">
                                            <i class="el-icon-star-on"/>
                                            <span style="position: absolute; left: 28px; top: 6px; width: auto;white-space:nowrap;">
                                            {{getMilestone(task.uuid, week).title+(getMilestone(task.uuid, week).overDue || "")}}
                                        </span>
                                                </template>
                                            </td>
                                        </template>
                                        <template v-if="k === 2">
                                            <td v-for="week in weeks" v-bind:key="week + k" :class="{
                                        task: task.status.hasOwnProperty(week),
                                        milestone: milestoneStatusIsNull(task.uuid, week),
                                        height32: true, width32: true,
                                    }" style="color: #909399;">
                                                <template v-if="milestoneStatusIsNull(task.uuid, week, k)">
                                                    <i class="el-icon-star-off" style="font-size: 24px; line-height: 28px;"></i>
                                                    <span style="position: absolute; left: 28px; top: 6px; width: auto;white-space:nowrap;">
                                            {{getMilestone(task.uuid, week).title}}
                                        </span>
                                                </template>
                                            </td>
                                        </template>

                                    </tr>
                                </template>
                            </template>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <table style="margin-left: 10px;">
            <tr>
                <td>
                    <el-button v-if="editable" class="editBtn" type="primary" v-on:click="editPlan">编辑</el-button>
                    <el-button class="saveTemBtn"  v-on:click="saveAsTemplate">保存为模板</el-button>
                    <el-button type="primary" @click="exportToExcel">导 出</el-button>
                </td>
                <td style="width: 100px;">
                </td>
                <td style="font-size: 16px;">
                    里程碑状态描述：
                </td>
                <td style="font-size: 16px;padding: 10px;">
                    <i class="el-icon-star-off" style="font-size: 16px;"/>
                    <span>
                          里程碑计划
                    </span>
                </td>
                <td class="milestone-complete" style="font-size: 16px;padding: 10px;">
                    <i class="el-icon-star-on" style="font-size: 20px;"/>
                    <span>
                          里程碑已完成
                    </span>
                </td>
                <td class="milestone-serious-delay height32" style="font-size: 16px;padding: 10px;">
                    <i class="el-icon-star-on" style="font-size: 20px;"/>
                    <span>
                          里程碑已逾期
                    </span>
                </td>
            </tr>
        </table>

        <el-dialog title="保存为模板" :visible.sync="templateVisible" width="30%">
            <el-form label-position="right" label-width="100px">
                <el-form-item label="模板名称" :required="templateVisible" :error="errorMsg">
                    <el-input v-model="templateName" placeholder="请填写模板名称" style="width: 100%;"/>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input type="textarea" placeholder="请填写模板的说明" v-model="templateRemark" :rows="3"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="templateVisible=false">取 消</el-button>
            <el-button type="primary" @click="templateConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import _ from 'lodash';
    import {plan} from "../../../mixins/plan";
    import '../../../assets/plan.css';
    import planTaskService from "../../../service/planTaskService";
    import {API_URL} from "../../../common/config";

    export default {
        mixins: [plan],
        data: function () {
            return {
                screenHeight: window.innerHeight,
                range: {
                    start: '',
                    end: ''
                },
                tasks: [],
                mode: 'complete',
                milestones: [],
                templateVisible: false,
                templateName: '',
                templateRemark: '',
                errorMsg: "",
                editable: false
            }
        },
        created: async function(){
            this.editable = this.$route.query.isEditable==="true";
            let res = await planTaskService.getTaskStatusInfo(this.$route.query.projectId);
            if(res.data.Status==="1"){
                if(res.data.Data.tasks.length>0){
                    this.tasks = res.data.Data.tasks;
                    this.milestones = res.data.Data.milestones;
                    this.range.start = res.data.Data.startTime;
                    this.range.end = res.data.Data.endTime;
                }
            }
        },
        mounted:function () {
            document.body.style.overflow='auto';
            this.$refs.right.style.maxWidth= "" + this.$refs.table.offsetWidth - 470 + "px";//减470是减去左侧div宽度
            this.$refs.firstRowLayer.style.maxWidth= "" + this.$refs.table.offsetWidth - 487 + "px";
            this.$refs.tableContainer.style.height= "" + this.$refs.table.offsetHeight - 64 + "px"; //减去th高度和滚动条高度
            this.$refs.firstColLayer.style.height= "" + this.$refs.table.offsetHeight - 81 + "px";
        },
        watch: {},
        computed: {
            groupedTasks() {
                return _.groupBy(this.tasks, function (task) {
                    return task.stage;
                });
            }
        },
        methods: {
            tableDivScroll () {
                const $target = this.$refs.tableContainer
                // 行固定
                this.$refs.firstRowLayer.scrollLeft = $target.scrollLeft
                // 列固定
                this.$refs.firstColLayer.scrollTop = $target.scrollTop
            },
            async mark(task, week, status) {
                if(!this.editable){
                    return;
                }
                if (task.status.hasOwnProperty(week)) {
                    if (task.status[week] === status) {
                        let resp = await planTaskService.updateTaskStatusInfo(task.uuid, week, "");
                        if(resp.data.Status==="1"){
                            task.status[week] = null;
                            this.$message({
                                message:"任务状态更改成功！",
                                type:"success",
                                duration: 800
                            });
                        }
                    } else {
                        let resp = await planTaskService.updateTaskStatusInfo(task.uuid, week, status);
                        if(resp.data.Status==="1"){
                            task.status[week] = status;
                            this.$message({
                                message:"任务状态更改成功！",
                                type:"success",
                                duration: 800
                            });
                        }
                    }
                }
            },
            editPlan(){
                this.$router.push({
                    path: 'Edit',
                    query: {
                        projectId: this.$route.query.projectId,
                        isEditable: this.$route.query.isEditable
                    }
                });
            },
            saveAsTemplate(){
                this.templateVisible = true;
            },
            async templateConfirm(){
                if(this.templateName===""){
                    this.errorMsg = "请填写模板名称";
                    return;
                }
                let resp = await planTaskService.saveAsTemplate(this.templateName, this.templateRemark, this.tasks);
                if(resp.data.Status==="1"){
                    if(resp.data.Data.length>0){
                        this.errorMsg = resp.data.Data;
                    }else{
                        this.$message({
                            message:"模板保存成功！",
                            type:"success",
                            duration:800
                        });
                        this.templateVisible = false;
                    }
                }
            },
            exportToExcel() {
                let input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'json');
                let content = JSON.stringify({
                    months: this.months,
                    groupedTasks: this.groupedTasks,
                    milestones: this.milestones
                });
                input.setAttribute('value', content);
                let form = document.createElement('form');
                form.setAttribute('style', 'display:none');
                form.setAttribute('target', '_blank');
                form.setAttribute('method', 'post');
                form.setAttribute('action', API_URL + '/crm/crm/project/export/plan');
                form.appendChild(input);
                document.body.appendChild(form);

                form.submit();
                document.body.removeChild(form);
            }
        }
    }
</script>
<style scoped>
    .table-content {
        overflow-y: hidden;
    }
    .serious-delay {
        background: #F56C6C;
    }

    .slight-delay {
        background: #E6A23C;
    }

    .complete {
        background: #67C23A;
    }

    .serious-delay-legend {
        color: #F56C6C;
    }

    .slight-delay-legend {
        color: #E6A23C;
    }

    .complete-legend {
        color: #67C23A;
    }

    .milestone-complete {
        color: #67C23A;
    }

    .milestone-slight-delay {
        color: #E6A23C;
    }

    .milestone-serious-delay {
        color: #F56C6C;
    }

    .btn-task-complete {
        border: 1px solid #67C23A;
        color: #67C23A;
        padding: 3px 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .btn-task-complete.active {
        color: white;
        background: #67C23A;
    }

    .btn-task-slight-delay {
        border: 1px solid #E6A23C;
        color: #E6A23C;
        padding: 3px 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .btn-task-slight-delay.active {
        color: white;
        background: #E6A23C;
    }

    .btn-task-serious-delay {
        border: 1px solid #F56C6C;
        color: #F56C6C;
        padding: 3px 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .btn-task-serious-delay.active {
        color: white;
        background: #F56C6C;
    }
    .left-content{
        width:440px;
        float:left;
    }
    .right-content{
        float:left
    }
    .table-head{
        width:100%;
        overflow:hidden;
    }
    .left-content .table-body{
        overflow:hidden;
    }
    .table-left .table{
        background-color:#FFFFFF;
        overflow:hidden;
        margin-right:0;
        padding-right:0;
    }
    /*.table::-webkit-scrollbar{display:none}*/
    .content-table td, .full-table td {
        text-align: center;
        word-wrap: break-word;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
    }
    .table-content th{
        height:32px;
        display: inline-block;
        /*line-height:14px;*/
        padding:auto 0;
        margin:auto 0;
        vertical-align: middle;
    }
    .table-content th,.table-content td {
        border: 1px double #dcdfe6;
    }
    .content-table {
        /*display:block;*/
    }
    thead,tbody{
    }
    .content-table tr:first-child td,.table-left tr:first-child td {
        border-top: none;
    }
    .table-left tr td:last-child {
        border-right:none;
    }
</style>